<template>
  <div class="vz-personal-order-total-container-sticky">
    <vz-order-total-price
      :has-toggle="priceToggle"
      @send-form="emit('send-form')"
      @get-price="orderStore.getOrderPriceAction"
      @create-draft="orderStore.createDraft"
    />
    <vz-card v-if="linkedOrders">
      <vz-order-view-total-linked-orders />
    </vz-card>
    <vz-cod-card v-if="isPersonal"/>
    <vz-manifest-card v-if="hasManifest"/>
    <vz-card v-if="hasDiagram">
      <vz-order-diagram
        class="vz-personal-order-total-card-item"
        :order="orderStore.orderForm"
      />
    </vz-card>
  </div>
</template>

<script setup lang="ts">
import VzOrderTotalPrice from '~/components/personal/order/vz-order-total-price.vue';
import VzCard from '~/components/ui-kit/vz-card.vue';
import VzOrderDiagram from '~/components/personal/order/vz-order-diagram.vue';
import VzOrderViewTotalLinkedOrders
  from '~/components/personal/order/vz-order-view/total/vz-order-view-total-linked-orders.vue';
import VzCodCard from '~/components/personal/order/vz-cod-card.vue';
import {useOrderStore} from '~/stores/order';
import VzManifestCard from '~/components/personal/order/vz-manifest-card.vue';

const emit = defineEmits(['send-form'])

const props = defineProps({
  priceToggle: {
    type: Boolean,
    default: true
  }
})

const orderStore = useOrderStore()
const route = useRoute()

const isPersonal = computed(() => {
  return route.path.startsWith('/personal/') || useRoute().path.startsWith('/old-personal/')
})

const linkedOrders = computed(() => {
  return orderStore.orderForm.linkedOrders
})

const hasManifest = computed(() => {
  const manifest = orderStore.orderForm.meta?.isLoadingManifestFilled
  return manifest === true || manifest === false
})

const hasDiagram = computed(() => {
  if ((orderStore.orderForm.meta?.guid && orderStore.orderForm.meta.state === 0) || orderStore.costDisabledReason) {
    return false
  }
  return !!orderStore.orderForm.shippingDiagram?.length
})
</script>

<style lang="scss" scoped>

</style>
